import { Switch, Router, useParams } from "react-router-dom";
import React, {
  Suspense,
  lazy,
  useContext,
  useEffect,
  useState,
  useCallback,
} from "react";
import AppContext from "../../helpers/context";
import { Redirect } from "react-router-dom";
import history from "../../config/history";
import PrivateRoute from "../../helpers/privateRoutes"; // Private Routes, Will only accessible after Login
import AuthRoute from "../../helpers/authRoutes"; // Auth Routes, Will only accessible before login.
import NavBar from "../../components/NavBar/NavBar";
import SideBar from "../../components/SideBar/SideBar";
import Spinner from "../../components/Spinner/Spinner";
import VerificationView from "../VerificationView/VerificationView";
import LeadsManager from "../LeadsManager/LeadsManager";
import SettingsRouter from "../Settings/Settings.index";
import LeadDetailIndex from "../LeadDetails/LeadDetail.index";
import ForgotPassword from "../Forgot Password";
import LearningCenter from "../LearningCenter/LearningCenter";
import CourseDetails from "../../components/learning-center/CourseDetails";
import WorkshopsDetails from "../WorkshopsDetails/WorkshopsDetails";
import PopUpModal from "../../components/Modals/PopUpModal";
import ShortsDetails from "../../components/short-details";
import Analytics from '../Analytics';
import CreatePassword from "../Signup-Form/CreatePassword";
import LoginDemo from "../Signup-Form/LoginDemo";
import ProjectLaunchpad from "../ProjectLaunchpad";
import CreateProjects from "../Settings/Projects/CreateProjects";
import BasicDetails from "../../components/Projects/BasicDetails";
import ProjectDetail from "../ProjectLaunchpad/ProjectDetail";
import Inventory from "../Inventory";
import BookingEOI from "../BookingEOI";
import CollectionManager from "../Collection-Manager";
import CollectionDetail from "../Collection-Manager/CollectionDetail";
import Projects from "../Settings/Projects/Projects";
import TeamInfo from "../../components/Projects/TeamInfo";
import PaymentPlan from "../../components/Projects/PaymentPlan";
import PricingModule from "../../components/Projects/PricingModule";
import AdditionalInfo from "../../components/Projects/AdditionalInfo";
import MediaUpload from "../../components/Projects/MediaUpload";
import ForgotPasswordOptions from "../ForgotPassword/ForgotPasswordOptions";
import MobileForOTP from "../ForgotPassword/PasswordViews/EnterMobileNumberModal";
import CreateEvent from "../Events/CreateEvent";
import Team from "../../components/Projects/Team";
import ConstructionUpdate from "../../components/Projects/ConstructionUpdate";
import { fetchToken, onMessageListener } from "../../firebase";
import CompanyAnalytics from "../PropacityPlus/Company";
import Dashboard from "../PropacityPlus/Dashboard";
import UsersReferral from "../PropacityPlus/UsersReferral";
import CreateBanner from "../PropacityPlus/CreateBanner";
import Broker from "../../components/Projects/Broker";
import Consumer from '../../helpers/context';
import CreateProject from "../ListingProjects/CreateProject";
// import CompanyAnalytics from "../Settings/AppAnalytics/CompanyAnalytics/Company";

// import Signup from "../Signup-Form/Signup";

const Login = lazy(() => import("../Login"));
const Signup = lazy(() => import("../Signup-Form/signup"));
const SignupForm = lazy(() => import("../Signup-Form"));
const Lead = lazy(() => import("../Lead"));
// const forgotPassWord = lazy(() => import('../Forgot Password'));
const home = lazy(() => import("../Home"));
const leaddetails = lazy(() => import("../Lead Details"));
const csv = lazy(() => import("../CSV"));
const forgotPassword = lazy(() => import("../ForgotPassword/ForgotPassword"));
const verifyPassword = lazy(() => import("../ForgotPassword/VerifyPassword"));

const Erropage = lazy(() => import("../Erropage"));

// const Settings = lazy(() => import('../Settings/settings'));
const apiKey = "AIzaSyDRuni-c1oJBFaF8ahTxlxPmYyCmRRtclw";
const mapApiJs = "https://maps.googleapis.com/maps/api/js";

function loadAsyncScript() {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    Object.assign(script, {
      type: "text/javascript",
      async: true,
      src: `${mapApiJs}?key=${apiKey}&libraries=places&v=weekly`,
    });
    script.addEventListener("load", () => resolve(script));
    document.head.appendChild(script);
  });
}

// Root routes
const AllRoutes = () => {
  const [showNetworkModal, setShowNetworkModal] = useState(false);
  const [authToken, setAuthToken] = useState(localStorage.getItem("authToken"));
  const [notification, setNotification] = useState({ title: '', body: '' });
  const [isTokenFound, setTokenFound] = useState(false);

  const { userProfile } = useContext(Consumer)
  fetchToken(setTokenFound);
  // const params = useParams();

  // const params = useParams();

  const toggleSidebar = useCallback(() => {
    const el = document.getElementById("main-container");
    if (el.classList.contains("open-sidebar")) {
      el.classList.remove("open-sidebar");
      document.getElementById('hamburger_icon').style.display = 'block';
      document.getElementById('close_icon').style.display = 'none';
    } else {
      el.classList.add("open-sidebar");
      document.getElementById('hamburger_icon').style.display = 'none';
      document.getElementById('close_icon').style.display = 'block';
    }
  }, []);

  useEffect(() => {
    // if script already loaded
    if (window.google) {
      return Promise.resolve();
    }
    loadAsyncScript();

    onMessageListener().then(payload => {
      // setShow(true);
      setNotification({ title: payload.notification.title, body: payload.notification.body })

    }).catch(err => console.log('failed: ', err));

    window.addEventListener("online", () => setShowNetworkModal(false));
    window.addEventListener("offline", () => setShowNetworkModal(true));

    return () => {
      window.removeEventListener("online", () => { });
      window.removeEventListener("offline", () => { });
    };
  }, []);

  const Routes = (props) => {
    // const { authorized } = useContext(AppContext)
    const authorized = localStorage.getItem("authToken") ? true : false;
    return (
      <Router history={history}>
        {authorized ? (
          <NavBar {...props} toggleSidebar={toggleSidebar} />
        ) : (
          <></>
        )}
        <div className={`main-div show-loader`} id="main-container">
          {authorized ? (
            <SideBar {...props} toggleSidebar={toggleSidebar} />
          ) : (
            <></>
          )}
          <Spinner />
          {showNetworkModal && (
            <PopUpModal
              show={showNetworkModal}
              setShow={setShowNetworkModal}
              body={
                <div className="no-internet">
                  <figure className="d-table mx-auto mb-20">
                    {/* <img src='assets/no_internet.png' /> */}
                    <img
                      id="image0_3256_61607"
                      width="108"
                      height="108"
                      src="data:image/png;base64,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"
                    />
                  </figure>
                  <h1 className="text-cetner fz24 fw-po-medium black mb-12">
                    No Internet Connection!
                  </h1>
                  <p className="text-center black-dark-700 fz16 fw-po-medium">
                    Please check your network connection and try again.
                  </p>
                  <button
                    className="pr-btn fz14 px-16 py-8"
                    onClick={() => {
                      window.location.reload();
                    }}
                  >
                    Reload Page
                  </button>
                </div>
              }
            />
          )}
          <Suspense fallback={<Spinner requesting={true}></Spinner>}>
            <Switch>
              <Redirect exact={true} from="/" to="login" />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/activity"
                component={home}
              />
              <AuthRoute
                exact={true}
                authorized={authorized}
                path="/login"
                component={Login}
              />
              {/* < AuthRoute exact={true} authorized={authorized} path="/signup" component={Signup} /> */}
              <AuthRoute
                exact={true}
                authorized={authorized}
                path="/signupform/:uuid"
                component={SignupForm}
              />
              <AuthRoute
                exact={true}
                authorized={authorized}
                path="/loginflow/:uuid"
                component={Signup}
              />
              <AuthRoute
                exact={true}
                authorized={authorized}
                path="/login-demo"
                component={LoginDemo}
              />
              <AuthRoute
                exact={true}
                authorized={authorized}
                path="/create-password/:uuid"
                component={CreatePassword}
              />
              <AuthRoute
                exact={true}
                authorized={authorized}
                path="/verifylink/:uuid"
                component={VerificationView}
              />
              <AuthRoute
                exact={true}
                authorized={authorized}
                path="/forgotpassword/:uuid"
                component={verifyPassword}
              />
              <AuthRoute
                exact={true}
                authorized={authorized}
                path="/setPassword/:uuid"
                component={verifyPassword}
              />

              <AuthRoute
                exact={true}
                authorized={authorized}
                path="/forgotpassword"
                component={ForgotPasswordOptions}
              />
              <AuthRoute
                exact={true}
                authorized={authorized}
                path="/forgotpassword-email"
                component={forgotPassword}
              />
              <AuthRoute
                exact={true}
                authorized={authorized}
                path="/forgotpassword-otp"
                component={MobileForOTP}
              />

              <PrivateRoute
                authorized={authorized}
                path="/leads/:id"
                component={LeadDetailIndex}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/leads"
                component={LeadsManager}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/leads-manager"
                component={Lead}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/csv"
                component={csv}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/learning-center"
                component={LearningCenter}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/inventory"
                component={Inventory}
              />

              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/learning-center/course-detail/:id"
                component={CourseDetails}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/booking-eoi"
                component={BookingEOI}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/collection-manager"
                component={CollectionManager}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/collection-manager/detail/:uuid"
                component={CollectionDetail}
              />

              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/project-launchpad"
                component={ProjectLaunchpad}
              />

              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/project-launchpad/details/:uuid"
                component={ProjectDetail}
              />
              {/* <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/create-Event"
                component={CreateEvent}
              /> */}

              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/workshops-details/:id"
                component={WorkshopsDetails}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/shorts-details/:id"
                component={ShortsDetails}
              />
              <PrivateRoute
                authorized={authorized}
                path="/settings/:section/:component"
                component={SettingsRouter}
              />
              <PrivateRoute
                authorized={authorized}
                path="/leaddetail/:id"
                component={leaddetails}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/projects"
                component={Projects}
              />

              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/plus-app"
                component={Dashboard}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/plus-app/refer-earn/:uuid"
                component={UsersReferral}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/plus-app/banner/create"
                component={CreateBanner}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/plus-app/banner/create/:uuid"
                component={CreateBanner}
              />

              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/projects/create-projects/basic-details"
                component={+userProfile?.company_id === +process.env.REACT_APP_COMPANY_ID ? CreateProject : BasicDetails}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/projects/create-projects/basic-details/:uuid"
                component={+userProfile?.company_id === +process.env.REACT_APP_COMPANY_ID ? CreateProject : BasicDetails}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/projects/create-projects/mediaupload/:uuid"
                component={MediaUpload}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/projects/create-projects/additional-info/:uuid"
                component={AdditionalInfo}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/projects/create-projects/payment-plan/:uuid"
                component={PaymentPlan}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/projects/create-projects/construction-updates/:uuid"
                component={ConstructionUpdate}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/projects/create-projects/pricing/:uuid"
                component={PricingModule}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/projects/create-projects/broker-cp/:uuid"
                component={Broker}
              />

              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/projects/create-projects/team-info/:uuid"
                component={TeamInfo}
              />
              <PrivateRoute
                exact={true}
                authorized={authorized}
                path="/projects/create-projects/team/:uuid"
                component={Team}
              />

              <PrivateRoute exact={true} authorized={authorized} path="/analytics" component={Analytics} />
              {/* <PrivateRoute exact={true} authorized={authorized} path="/settings" component={forgotPassWord} /> */}
              <PrivateRoute
                authorized={authorized}
                path="/404"
                component={Erropage}
              />
              <Redirect from="*" to="/404" />
            </Switch>
          </Suspense>
        </div>
      </Router>
    );
  };
  return <Routes />;
};

// function mapStateToProps(state){
//             return state
// }

export default AllRoutes;
